import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AdminContext } from './AdminContext';

export default function ProtectedRoute({ children }) {
  const { user, token } = useContext(AdminContext);
  if (!token || !user) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}
